import React, { useEffect, useState } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { ChevronLeft as ChevronLeftIcon, Pencil as PencilIcon } from 'lucide-react';

import DetailDisplay from './DetailDisplay';

const GET_USER = gql`
    query GetUserDetail(
        $getRid: String
    ) {
        userdetail(
            getRid: $getRid
        ) {
            result{
                rid
                firstName
                lastName
                casedUsername
                userType
                lastLogin
                email
                status
            }
            responseType
            responseInfo
        }
    }
`;

export default function DetailUser(props) {
    const { isMobile } = props;
    const location = useLocation();
    const updateActionInit = location?.state?.modify || false;
    const [updateAction, setUpdateAction] = useState(false);

    let { rid } = useParams();

    let navigate = useNavigate();

    const [getDetail, { error, loading, data }] = useLazyQuery(
        GET_USER, { fetchPolicy: "network-only", variables: { "getRid": rid } }
    );

    useEffect(() => {
        getDetail();
    }, [rid]);

    useEffect(() => {
        setUpdateAction(updateActionInit);
    }, [updateActionInit]);

    const navGoBack = () => {
        navigate(-1);
    }

    const editBtnAction = () => {
        navigate(`/users/modify/${rid}`)
    }

    return (
        <Box component="main" sx={{flexGrow: 1,height: '100vh',overflow: 'auto',}}>
        <Container sx={{ marginTop: '80px' }} maxWidth="xl">

            <Grid container direction="row" justifyContent="space-between" alignItems="flex-end" spacing={2} sx={{ marginBottom: '8px' }}>
                <Grid item>
                    {isMobile ?
                        <Button onClick={navGoBack} aria-label="go back"><ChevronLeftIcon strokeWidth={1} /></Button>
                        :
                        <Button onClick={navGoBack} aria-label="go back" startIcon={<ChevronLeftIcon strokeWidth={1} />}>Go Back</Button>
                    }
                </Grid>
                <Grid item md order={{ xs: 2, md: 3 }}>
                </Grid>
                <Grid item order={{ xs: 2, md: 3 }}>
                    <Grid item>
                        {isMobile ?
                            <Button aria-label="edit" variant="outlined" onClick={editBtnAction}><PencilIcon strokeWidth={1} /></Button>
                            :
                            <Button aria-label="edit" variant="outlined" onClick={editBtnAction} endIcon={<PencilIcon strokeWidth={1} size={14} />}>Edit User</Button>
                        }
                    </Grid>
                </Grid>
            </Grid>

            {updateAction &&
                <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ marginTop: '12px', marginBottom: '12px' }}>
                    <Grid item>
                        <Alert severity="success" variant="outlined" onClose={() => { setUpdateAction(false); }}>
                            <AlertTitle>User Modified</AlertTitle>
                            This user was {updateAction} successfully!
                        </Alert>
                    </Grid>
                </Grid>
            }

            {error ?
                <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ marginTop: '20%' }}>
                    <Grid item>
                        <Alert severity="error" variant="outlined">
                            <AlertTitle>Error</AlertTitle>
                            There was an error processing this request. Please try again or contact us for support!
                        </Alert>
                    </Grid>
                </Grid>
                :
                loading ?
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
                        <CircularProgress sx={{ color: '#c9fb00' }} thickness={1} size={60} />
                    </Backdrop>
                    :
                    <DetailDisplay data={data} />
            }

        </Container>
        </Box>
    );
}